import api from './api';

export async function getFaqs() {
  const response = await api.get('/faqs');
  return response.data;
}

export async function upsertFaq(payload) {
  const response = await api.post('/admin/faqs', payload);
  return response.data;
}

export async function deleteFaq(faqId) {
  const response = await api.delete(`/admin/faqs/${faqId}`);
  return response.data;
}
